import { Filter } from "bad-words";

const filter = new Filter();

export function filterProfanity(text) {
  if (!text) return text;
  try {
    return filter.clean(text);
  } catch {
    return text;
  }
}
